import { Modal } from '@seiue/ui'

import { EditTaskProps } from '../types'

import { EditQuizTaskModal } from './EditQuizTaskModal'

/**
 * 打开编辑测验任务弹窗
 *
 * @param param - 参数
 * @param param.taskId - 任务 ID
 * @param param.activityId - 活动 ID
 * @param param.activityTaskOptions - 活动选项
 */
export const openEditQuizTask = ({
  activityId,
  taskId,
  activityTaskOptions,
}: EditTaskProps) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <EditQuizTaskModal
        onClose={() => {
          hide()
        }}
        taskId={taskId}
        activityId={activityId}
        activityTaskOptions={activityTaskOptions}
      />
    ),
  })
}
